import { jsx as _jsx } from "react/jsx-runtime";
export function AnimatedLink(props) {
    return (_jsx("a", { href: props.url, target: props.target, className: "animated-link", children: _jsx("div", { className: "animated-link-border", children: props.title }) }));
}
